export interface EmployeeIDCard {
  idType: string;
  effectiveDate: string;
  idNumber: string;
  dateOfIssue: string;
  placeOfIssue: string;
  expiryDate: string;
  employeeId: number;
  organizationId: number;
  updatedBy: UpdatedBy;
  createdBy: UpdatedBy;
  status: number;
  uniqueStatus: string;
  deletedAt?: string;
  frontOfImage?: string;
  backOfImage?: string;
  id: number;
  createdAt: string;
  updatedAt: string;
}

interface UpdatedBy {
  userId: number;
  fullName: string;
  employeeId: number;
}

export interface EmployeeIDCardListRequest {
  employeeId: number;
  page?: number;
  limit?: number;
  keyword?: string | null;
  status?: number | null;
}

export interface EmployeeIDCardCreateRequest {
  employeeId: number;
  idType: string;
  effectiveDate: string;
  idNumber: string;
  dateOfIssue: string;
  placeOfIssue: string;
  expiryDate?: string;
}

export interface EmployeeIDCardUpdateRequest
  extends EmployeeIDCardCreateRequest {
  id: string;
}

export interface EmployeeIDCardListResponse extends RestAPIMetaResponse {
  items: Array<EmployeeIDCard>;
}

export enum EmployeeIDCardType {
  CitizenIDCard = "CitizenIDCard",
  DriverLicense = "DriverLicense",
  IDCard = "IDCard",
  Passport = "Passport",
  PIN = "PIN",
}
